module.exports = __webpack_public_path__ + "img/business-energy.e5ed0d6.webp";